// --- Core ---
import {Action, Reducer} from "@reduxjs/toolkit";

const CLEAR_SECRETS = "CLEAR_SECRET";

/**
 * Resets all reducers that are decorated as secret.
 * Should be called after logout.
 */
export function clearSecrets() {
  return {
    type: CLEAR_SECRETS
  };
}

/**
 * A decorator for reducers that will be cleared when dispatching the clearSecrets action.
 * The decorated reducer will be called with an undefined state, the same as when the reducer
 * is initialized.
 *
 * @param reducer The reducer that contains a state which should be a secret
 */
export function secret<S = unknown, A extends Action = Action>(reducer: Reducer<S, A>): Reducer<S, A> {
  return (state, action) => {
    if (action.type === CLEAR_SECRETS) {
      return reducer(undefined, action);
    }

    return reducer(state, action);
  };
}
